import React, { memo } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    CircularProgress,
} from '@mui/material'
import { translate } from '../i18n'
import DialogButton from './DialogButton'
import { DialogPopupProps } from './DialogPopup.types'

function DialogPopup({
    title,
    variant = 'primary',
    children,
    open = true,
    onClose,
    closeText = translate(
        variant === 'error' ? 'buttons.cancel' : 'buttons.close'
    ) as string,
    button,
    leftButton,
    disable,
    disableBackdropClick,
    disableEscapeKeyDown,
    fullScreen = false,
    fullWidth = true,
    maxWidth = 'sm',
}: DialogPopupProps) {
    const onCloseClick = (
        event: {},
        reason: 'backdropClick' | 'escapeKeyDown'
    ) => {
        if (disableBackdropClick !== false && reason === 'backdropClick') {
            return
        }
        if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
            return
        }
        onClose()
    }

    return (
        <Dialog
            open={open}
            maxWidth={maxWidth}
            fullScreen={fullScreen}
            fullWidth={fullWidth}
            scroll="paper"
            onClose={onCloseClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent sx={{ paddingBottom: 2 }}>{children}</DialogContent>
            <DialogActions sx={{ paddingX: 3 }}>
                <Grid
                    container
                    justifyContent="flex-start"
                    direction="row-reverse"
                    alignContent="center"
                    alignItems="center"
                    spacing={1}
                >
                    <Grid item xs>
                        <Grid
                            container
                            justifyContent="flex-start"
                            direction="row-reverse"
                            alignItems="center"
                            spacing={1}
                        >
                            {button && (
                                <Grid item xs="auto">
                                    <DialogButton
                                        {...button}
                                        variant={variant}
                                    />
                                </Grid>
                            )}
                            <Grid item xs="auto">
                                <DialogButton
                                    variant="close"
                                    text={closeText}
                                    disabled={disable}
                                    onClick={onClose}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    {leftButton && (
                        <Grid item xs="auto">
                            {!!leftButton.loading && (
                                <CircularProgress
                                    size="1rem"
                                    color="secondary"
                                />
                            )}
                            {!leftButton.loading && (
                                <DialogButton {...leftButton} variant="left" />
                            )}
                        </Grid>
                    )}
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default memo(DialogPopup)
